import { Link } from "react-router-dom";
import { CheckCircle, Phone, ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";

const SuccessPage = () => {
  return (
    <div data-testid="success-page" className="pt-32 lg:pt-36">
      <SEO 
        title="Thank You - Quote Request Received | C. Glancey Double Glazing"
        description="Thank you for your enquiry. We have received your quote request and will be in touch shortly."
        canonical="/success"
      />
      
      {/* Success Content */}
      <section className="py-20 bg-white min-h-[60vh] flex items-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Success Icon */}
          <div className="mb-8">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="w-14 h-14 text-green-500" />
            </div>
          </div>
          
          {/* Heading */}
          <h1
            className="text-4xl sm:text-5xl font-black text-[#0A0A0A] mb-4"
            style={{ fontFamily: "'Chivo', sans-serif" }}
          >
            THANK <span className="text-[#FF6B00]">YOU!</span>
          </h1>
          
          {/* Message */}
          <p className="text-xl text-[#525252] mb-4">
            Your quote request has been received successfully.
          </p>
          <p className="text-[#525252] mb-8">
            We'll review your enquiry and get back to you as soon as possible, usually within 24 hours.
          </p>
          
          {/* What's Next Box */}
          <div className="bg-[#F5F5F5] p-8 mb-8 text-left">
            <h2 
              className="text-xl font-black text-[#0A0A0A] mb-4"
              style={{ fontFamily: "'Chivo', sans-serif" }}
            >
              WHAT HAPPENS NEXT?
            </h2>
            <ul className="space-y-3 text-[#525252]">
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-[#FF6B00] text-white flex items-center justify-center flex-shrink-0 text-sm font-bold">1</span>
                <span>We'll review your requirements and prepare a tailored quote</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-[#FF6B00] text-white flex items-center justify-center flex-shrink-0 text-sm font-bold">2</span>
                <span>One of our team will contact you to discuss your project</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-[#FF6B00] text-white flex items-center justify-center flex-shrink-0 text-sm font-bold">3</span>
                <span>We'll arrange a free, no-obligation site visit if required</span>
              </li>
            </ul>
          </div>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              data-testid="success-home-btn"
              className="inline-flex items-center justify-center gap-2 bg-[#FF6B00] text-white font-bold uppercase tracking-wide px-8 py-4 hover:bg-[#E65000] transition-all"
            >
              Back to Home <ArrowRight className="w-5 h-5" />
            </Link>
            <a
              href="tel:07917181597"
              data-testid="success-call-btn"
              className="inline-flex items-center justify-center gap-2 bg-[#0A0A0A] text-white font-bold uppercase tracking-wide px-8 py-4 hover:bg-[#333] transition-all"
            >
              <Phone className="w-5 h-5" /> Call Us Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SuccessPage;
